import cn from 'classnames';
export interface GradientTextProps {
	testId?: string;
	children: React.ReactNode;
	variant?: 'default' | 'angle';
}

const GradientText = (props: GradientTextProps) => {
	const { children, testId = `GradientText`, variant = 'default' } = props;

	const classes = cn(
		'from-royal-orange via-raspberry-pink to-vivid-cerulean bg-clip-text text-transparent',
		{
			'bg-gradient-to-r': variant === 'default',
			'bg-gradient-to-br': variant === 'angle',
		},
	);

	return (
		<span data-testid={testId} className={classes}>
			{children}
		</span>
	);
};

export default GradientText;
